import React from 'react'

export default function StudentSearchInstructions() {
  return (
    <div className="alert-info p-2 mb-1">
      <p className="mb-0">Fill out at least one of the following fields with information relating to the student(s) you are looking for, and click "Search"</p>
    </div>
  )
}
